/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type ListAgentOptimizationsPathParams = NonNullable<operations['listAgentOptimizations']['parameters']['path']>;

export type ListAgentOptimizationsQueryParams = NonNullable<
  operations['listAgentOptimizations']['parameters']['query']
>;

export interface Input extends ListAgentOptimizationsPathParams {
  apiVersion?: string;
  query?: ListAgentOptimizationsQueryParams;
}

export async function listAgentOptimizations(
  { apiVersion, query, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/agent-optimizations', {
    params: { path, query },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
